export default {
  methods: {
    formatTimeStamp(time) {
      return time.substring(0, 5)
        .replace(/:/i, 'h');
    },
  }
};
